import { gql as apolloGql } from '@apollo/client'
import convertLiveDirectives from '@/lib/graphql/convert-live-directives'

export function gql(literals: TemplateStringsArray, ...placeholders: any[]) {
  const query = literals
    .reduce((acc, str, i) => acc + str + (placeholders[i] ?? ''), '')
    .trim()
  return convertLiveDirectives(apolloGql(query))
}
